import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as service from "./service";
import Translate from "../../../Components/Multilanguage/Translate";
const ResetPassword = () => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const { token } = useParams();
  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const handleUpdate = (item) => {
    const { name, value } = item?.target;
    handleChange(name, value);
  };
  const handleChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  const validatePassword = () => {
    let error = {};
    let validateStatus = true;
    const { password, confirmPassword } = values;
    let passwordRegex =
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (!password) {
      error.password = <Translate textKey={'password_required'}/>;
      validateStatus = false;
    }
    // else if (!password?.match(passwordRegex)) {
    //   error.password =
    //     "Password should be 8-20 characters and include at least 1 letter, 1 number and 1 special characters!";
    //   validateStatus = false;
    // }
    if (password != confirmPassword) {
      error.confirmPassword = <Translate textKey={'password_not_matching_message'}/>;
      validateStatus = false;
    }
    setErrors(error);
    return validateStatus;
  };

  const data = {
    password: values?.password,
    token: token,
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const validateStatus = validatePassword();
      if (validateStatus) {
        const response = await service.resetPassword(appInfo, data);
        if (response?.status === 200) {
          toast.success(response?.data?.message, {
            position: "top-center",
          });
          setTimeout(() => {
            navigate(projectInfo?.projectConfig?.pubid !== 50124 && projectInfo?.projectConfig?.config ?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout": "/login",{ state: {activeLogin: true}});
          }, 2000);
        } else {
          let error = {};
          error.message = response?.data?.message;
          setErrors(error);
        }
      } else {
        event.preventDefault();
        return false;
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-center",
      });
    }
    // const validateStatus = await validatePassword();
    // if (validateStatus) {
    //   service.resetPassword(data, appInfo).then((response) => {
    //     if (response?.success === true) {
    //       toast.success(response?.message, {
    //         position: "top-center",
    //       });
    //       setTimeout(() => {
    //        navigate('/login')
    //       }, 2000);
    //     } else {
    //       let error = {};
    //       error.message = response?.data?.message;
    //       setErrors(error);
    //     }
    //   });
    // } else {
    //   event.preventDefault();
    //   return false;
    // }
  };

  return (
    <div className="resetPassword" role="main" aria-label="Reset Password Page">
      <ToastContainer />
      <div className="wrapper">
        <h1 className="heading" id="reset-password-heading"><Translate textKey={'reset_password'}/></h1>
        <div className="contents" role="region" aria-label="Reset Password Contents">
          <div className="formSection" role="region" aria-label="Reset Password Form Section">
            <form aria-labelledby="reset-password-heading" aria-label="Reset Password Form">
              <div className="inputContainer">
                <label htmlFor="newpassword"><Translate textKey={'new_password'}/></label>
                <input
                  type="password"
                  id="newpassword"
                  name="password"
                  onChange={(e) => handleUpdate(e)}
                  aria-label="New Password"
                />

                {errors?.password && (
                  <span className="error">{errors.password}</span>
                )}
              </div>
              <div className="inputContainer">
                <label htmlFor="#confirmpassword"><Translate textKey={'confirm_password'}/></label>
                <input
                  type="password"
                  id="confirmpassword"
                  name="confirmPassword"
                  onChange={(e) => handleUpdate(e)}
                  aria-label="Confirm Password"
                />

                {errors.confirmPassword && (
                  <span className="error">{errors.confirmPassword}</span>
                )}
              </div>

              <div
                className="buttonContainer"
                onClick={(event) => {
                  handleSubmit(event);
                }}
                tabIndex={0}
                role="button"
                aria-label="Reset Password"
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleSubmit(e); }}
              >
                <div className="background"></div>
                <button type="submit" aria-label="Reset Password" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.target.click(); }}><Translate textKey={'reset_password'}/></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
